import React from "react";
import Container from "../../../../../../common-deprecated/styles/v2/toyota/globals/Container";
import GradeInfo from "./GradeInfo";
import Engines from "./Engines";
import DisclaimerContainer from "../common/disclaimer/DisclaimerContainer";
import { GreyBackground } from "../../../../../../common-deprecated/styles/v2/toyota/utilities/Background";

const SelectEngine = (): JSX.Element => (
    <>
        <GradeInfo />

        <GreyBackground mt={6} py={{ _: 3, lg: 6 }}>
            <Engines />

            <Container>
                <DisclaimerContainer />
            </Container>
        </GreyBackground>
    </>
);

export default SelectEngine;
